module.exports = __webpack_public_path__ + "img/value_mock.2c37ff2e.png";